<template>
  <div :class="['score', { not_div: loading }]">
    <Loading v-if="loading" />
    <div class="bgc table_div">
      <div class="title">
        <div class="sort_son_title">
          {{ itemTitle }}
        </div>
        <div v-if="scores && scores.length" class="right_div">
          <a-button class="btn" type="primary" ghost @click="downImg">
            {{ this.$t('exam.sing.downchart') }}
          </a-button>
        </div>
      </div>
      <NotData v-show="!scores.length && !loading" />
      <div v-show="scores.length" class="echarts">
        <div
          :id="id"
          :ref="id"
          class="echarts_list"
          style="height: 400px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from '@utils'
  // import ApiXy from '@lib/api.js'
  import * as echarts from 'echarts'
  import ecStat from 'echarts-stat'
  import Loading from '@comp/loading'
  // import reports from '@static/data/report/index.js'

  export default {
    name: 'Studentscore',
    components: {
      Loading
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      itemTitle: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        loading: false,
        query: {},
        scores: [], //散点图数据
        charts: null
      }
    },
    watch: {
      $route: {
        handler() {
          if (this.$route.query.classId || this.$route.query.seId) {
            this.scatterPlotData()
          }
        },
        deep: true
      }
    },
    mounted() {
      this.query = this.$route.query
      this.scatterPlotData()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      resizeChart() {
        if (this.charts) this.charts.resize()
      },
      //散点图的数据
      scatterPlotData() {
        let {
          meId,
          seId,
          dId: groupId,
          classId,
          examIsActive = 1,
          campusId
        } = this.$route.query
        let unionUrl = [
          'studentScoreScatterPoint',
          'studentScoreScatterPointUnion',
          'studentScoreScatterPointUnion'
        ]
        let params = {
          meId,
          seId,
          classId,
          groupId,
          campusId
        }
        let url = unionUrl[examIsActive]
        axios({
          url,
          params,
          loading: false
        }).then(res => {
          if (res.status) {
            let { seFullScore, meFullScore, multiAvg, singleAvg } = res.data
            this.scores = res.data.scores
            let source = res.data.scores.map(item => [
              item.essScore,
              item.messScore
            ])
            this.$nextTick(() => {
              this.scatterPlot(
                seFullScore,
                meFullScore,
                source,
                multiAvg,
                singleAvg
              )
            })
          }
        })
      },
      scatterPlot(
        itemMax = 100,
        totalMax = 300,
        source = [],
        multiAvg = 0,
        singleAvg = 0
      ) {
        let _this = this
        let scatterPlotBox = document.getElementById(this.id)
        console.log(
          scatterPlotBox.offsetWidth,
          '---bx---',
          this.id,
          this.charts
        )
        // 动态设置 内容的高度
        // scatterPlotBox.style.height = totalMax + 'px'

        this.charts = echarts.init(scatterPlotBox)

        //间距数
        let xSpace = 10
        let ySpace = 50
        //实际宽高 130是左右65
        let nWidth = +(scatterPlotBox.offsetWidth - 65 * 2).toFixed(2)
        //没有legend头部距离是44， 底部是26
        let nHeight = +(scatterPlotBox.offsetHeight - 44 - 26).toFixed(2)
        //获取转换画布X轴
        let getXNum = num => {
          return -(+(num / xSpace) * (nWidth / (itemMax / xSpace))).toFixed(2)
        }
        //获取转换画布Y轴
        let getYNum = num => {
          return -(+(num / ySpace) * (nHeight / (totalMax / ySpace))).toFixed(2)
        }
        echarts.registerTransform(ecStat.transform.regression)
        let option = {
          dataset: [
            {
              source
            },
            {
              transform: {
                type: 'ecStat:regression',
                config: {
                  // 线型回归
                  method: 'linear',
                  formulaOn: 'end'
                  // 'end' by default
                  // formulaOn: 'start'
                }
              }
            }
          ],
          tooltip: {
            trigger: 'item',
            axisPointer: {
              type: 'shadow',
              shadowStyle: {
                shadowColor: 'rgba(34, 87, 188, 0.1)'
              }
            },
            borderWidth: 0, //设置自定义边框宽度
            backgroundColor: 'none', //设置自定义背景
            extraCssText:
              //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
              'backdrop-filter: blur(10px)',
            formatter(params) {
              return (
                `<p class="toolTip">${_this.$t('exam.name')}: <span>${
                  _this.scores[params.dataIndex].studentName
                }</span> </p>` +
                `<p class="toolTip">${_this.$t('exam.totalScore')}: <span>${
                  params.value[1]
                }</span> </p>` +
                `<p class="toolTip">${_this.$t('exam.singSub')}: <span>${
                  params.value[0]
                }</span> </p>`
              )
            }
          },
          //  坐标的样式
          xAxis: {
            name: _this.$t('exam.singsubScore'),
            nameLocation: 'start',
            max: itemMax,
            offset: getYNum(multiAvg),
            interval: xSpace,
            nameTextStyle: {
              color: '#333'
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: '#5F8EEC'
              }
            }
          },
          yAxis: {
            name: _this.$t('exam.totalScore'),
            max: totalMax,
            offset: getXNum(singleAvg),
            interval: ySpace,
            nameTextStyle: {
              color: '#333'
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: '#5F8EEC'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          series: [
            {
              name: `${_this.$t('exam.totalScore')}:`,
              type: 'scatter',
              color: '#5f8eec',
              datasetIndex: 0
            },
            {
              name: `${_this.$t('exam.studentPointChart')}:`,
              type: 'line',
              color: '#ff8484',
              datasetIndex: 1,
              symbolSize: 0.1,
              symbol: 'circle',
              label: { show: false, fontSize: 14 },
              labelLayout: { dx: -20 },
              encode: { label: 2, tooltip: 1 }
            }
          ]
        }
        this.beforeEchart(option, source, { split: false })
        // this.cScroll(option, xTitle, 10)
        // 绘制图表
        this.charts.setOption(option)
        this.resizeChart()
      },
      beforeEchart(data, yTitle, params = {}) {
        let {
          split = true,
          splitNum = this.splitNum,
          abs = false,
          labelFc = null,
          person = false
        } = params
        let top
        if (data.legend && data.legend.data) {
          let baseNum = Math.ceil(data.legend.data.length / 10)
          top = baseNum * 40 + 24
        }
        //echarts距离处理
        let yName = data.yAxis && data.yAxis.name
        if (!data.grid) data.grid = {}
        if (!data.grid.top) data.grid.top = data.legend ? top : yName ? 44 : 34
        if (!data.grid.bottom) data.grid.bottom = 26
        if (!data.grid.left) data.grid.left = 65
        if (!data.grid.right) data.grid.right = 24

        //x轴处理
        if (Array.isArray(data.xAxis)) {
          data.xAxis.forEach(item => {
            if (!item.axisLabel) item.axisLabel = {}
            item.axisLabel.textStyle = {
              fontFamily: 'PingFangSC, PingFangSC-Regular',
              color: '#666666',
              fontSize: 14
            }
            item.axisTick = {
              show: false
            }
          })
        } else {
          if (!data.xAxis.axisLabel) data.xAxis.axisLabel = {}
          data.xAxis.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 14
          }
          data.xAxis.axisTick = {
            show: false
          }
          !data.xAxis.offset && (data.xAxis.offset = 4)
          if (!data.xAxis.axisLine) {
            data.xAxis.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              }
            }
          }
        }

        //Y轴处理
        if (!data.yAxis) data.yAxis = {}
        if (Array.isArray(data.yAxis)) {
          data.yAxis.forEach(item => {
            yDataFilter(item)
          })
        } else {
          yDataFilter(data.yAxis)
        }
        function yDataFilter(yData) {
          if (!yData.splitLine) {
            yData.splitLine = {
              show: false
            }
          }

          if (!yData.axisLabel) yData.axisLabel = {}
          yData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 12
          }
          if (!yData.axisLine) {
            yData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              },
              itemStyle: {
                color: '#666666'
              }
            }
          }
          if (!yData.splitArea) {
            yData.splitArea = {
              show: true,
              areaStyle: {
                color: ['#ddeeff', '#fff'],
                opacity: 0.3
              }
            }
          }
        }
        //分割处理

        if (split) {
          let max = yTitle
          if (Array.isArray(yTitle)) {
            max = Math.max(...yTitle)
          }
          if (Array.isArray(data.yAxis)) {
            data.yAxis.forEach(item => {
              labelDispose(item, max)
            })
          } else {
            let splitVal = max / splitNum
            if (abs) splitVal = splitVal * 2
            // 人数展示整数
            if (person) {
              if (splitVal % 1) {
                let num = splitVal % 1
                max += splitNum * (1 - num)
              }
              data.yAxis.minInterval = 1
              data.yAxis.interval = max / splitNum
            }
            if (!person) {
              data.yAxis.interval = splitVal
            }
            data.yAxis.max = max
            labelDispose(data.yAxis, max)
          }
        }
        function labelDispose(label, max) {
          //label处理
          label.axisLabel.formatter = value => {
            var texts = []
            let nums = Math.floor(max / splitNum)
            texts.push(+value.toFixed(nums ? 0 : 1) + (labelFc && labelFc()))
            return texts
          }
        }
      },
      downImg() {
        let box = this.$refs[this.id]
        var myChart = echarts.init(box)
        let { seName, classId } = this.query
        let className = +classId
          ? this.scores.filter(item => item.classId == classId)[0].className
          : this.$t('exam.grade')
        let aLink = document.createElement('a')
        aLink.download = `${seName}_${this.$t('exam.finalScore')}_${className}_${this.$store.state.subjectName}单科.png`
        aLink.style.display = 'none'
        aLink.href = myChart.getDataURL()
        document.body.appendChild(aLink)
        aLink.click()
        URL.revokeObjectURL(aLink.href)
        document.body.removeChild(aLink)
      }
      // importTo() {
      //   let { meId, seId, dId, classId } = this.$route.query

      //   let queryParams = {
      //     meId,
      //     seId,
      //     dId,
      //     classId
      //   }
      //   let queryList = []
      //   for (let q in queryParams) {
      //     if (queryParams[q] !== undefined) {
      //       queryList.push(`${q}=${queryParams[q]}`)
      //     }
      //   }
      //   let url =
      //     `${ApiXy.defaulteApi.host}${ApiXy.defaulteApi.path.reportnewexportstudenttranscript}?transcriptType=2&` +
      //     queryList.join('&') +
      //     '&X-ZYLX-TOKEN=' +
      //     getCookie('X-ZYLX-TOKEN')
      //   window.open(url, '_blank', '')
      // }
    }
  }
</script>
<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 4px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  .score {
    height: 100%;
    .top_div {
      min-height: 400px;
      margin-bottom: @padding-sm;
    }
    .echarts_list {
      width: 100%;
      height: 400px;
    }
    .table_div {
      height: calc(100% - 50px);
      min-height: 400px;
      // display: flex;
      // flex-direction: column;
      // padding: 20px 0;
    }
    .not_data_box {
      padding: 20px 0;
    }
  }
  // .not_div {
  // height: 400px;
  // }
</style>
